module.exports = __webpack_public_path__ + "0ad418d9af5bf4188d3bd925a3125a69.pdf";